module.exports = __webpack_public_path__ + "img/android-qr-code.710f069d.png";